// extracted by mini-css-extract-plugin
export var currencyInput = "_kn-1";
export var currencySymbol = "_kn-0";